<template>
  <div>
    <span v-if="rates != -1">
      {{ rates }}
    </span>
    <span v-else>
      <i class="el-icon-loading" style="font-size: 16px"></i> <span>{{ liveRates }}</span>
    </span>
  </div>
</template>

<script>


export default {
  props: {
    reqVendorId: {
      required: true,
    },
    ratesCount: {
      required: true,
    },
  },
  data() {
    return {
      rates: null,
      vendorId: null,
      liveRates: null,
      numberOfTries: 0,
      isRateBeingUploaded: false,
      sleepTime: [
        5000,
        12000,
        22000,
        34000,
        46000
      ]
    }
  },
  beforeMount() {
    this.vendorId = this.reqVendorId
    this.rates = this.ratesCount
    if (this.rates == -1) {
      this.isRateBeingUploaded = true
      this.liveVendorRatesCounter()
    }
  },
  methods: {
    liveVendorRatesCounter() {
      if (this.isRateBeingUploaded) {
        this.getVendorRatesCounter({id: this.vendorId}).then((r) => {
          this.isRateBeingUploaded = r.is_rate_being_uploaded
          this.liveRates = r.current_rates_counter
          setTimeout(() => {
            this.liveVendorRatesCounter()
          }, 6000)
        })
      } else {
        this.rates = this.liveRates
      }
    },
    ...$mapActions('voip-vendor-api', {getVendorRatesCounter: 'getVendorRatesCounter'}),
  }
}
</script>
